import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAlignRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="layout-align-right" maskId="round-filled-radius-0-stroke-1.5-IconLayoutAlignRight"><path fillRule="evenodd" clipRule="evenodd" d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75ZM17 7.75C17 7.33579 16.6642 7 16.25 7C15.8358 7 15.5 7.33579 15.5 7.75V16.25C15.5 16.6642 15.8358 17 16.25 17C16.6642 17 17 16.6642 17 16.25V7.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignRight;
